const arrow = 10;
const getPosition = (props) => {
    const { position, toggleParams, tooltipParams } = props;
    if (position === 'right' &&
        toggleParams.left + toggleParams.width + arrow + ((tooltipParams && tooltipParams.width) || 0) > window.innerWidth) {
        return 'left';
    }
    if (position === 'left' && toggleParams.left - arrow - ((tooltipParams && tooltipParams.width) || 0) < 0) {
        return 'right';
    }
    return position;
};
export const makeTooltipContainer = (props) => {
    const { align, toggleParams, tooltipParams } = props;
    const validatedPosition = getPosition(props);
    const tooltipPosition = {
        top: `top: ${toggleParams.top - ((tooltipParams && tooltipParams.height) || 0) - arrow}px`,
        bottom: `top: ${toggleParams.top + toggleParams.height + arrow}px`,
        left: `left: ${toggleParams.left - ((tooltipParams && tooltipParams.width) || 0) - arrow}px`,
        right: `left: ${toggleParams.left + toggleParams.width + arrow}px`,
    };
    const tooltipAlignV = {
        start: `top: ${toggleParams.top}px`,
        center: `top: ${toggleParams.top + toggleParams.height / 2 - ((tooltipParams && tooltipParams.height) || 0) / 2}px`,
        end: `top: ${toggleParams.top + toggleParams.height - ((tooltipParams && tooltipParams.height) || 0)}px`,
    };
    const tooltipAlignH = {
        start: `left: ${toggleParams.left}px`,
        center: `left: ${toggleParams.left + toggleParams.width / 2 - ((tooltipParams && tooltipParams.width) || 0) / 2}px`,
        end: `left: ${toggleParams.right - ((tooltipParams && tooltipParams.width) || 0) + arrow}px`,
    };
    return `
  position: fixed;
  ${tooltipPosition[validatedPosition]};
  ${validatedPosition === 'right' || validatedPosition === 'left' ? tooltipAlignV[align] : tooltipAlignH[align]};
  z-index: -100;
  visibility: hidden;
  opacity: 0;
  transition: opacity .3s ease-in-out;
  
  &.visible{
    opacity: 1;
    visibility: visible;
    z-index: 1;
  }`;
};
export const makeTooltipMessage = ({ width, background, color }) => {
    return `
  z-index: 20;
  background-color: ${background};
  padding: 12px;
  color: ${color};
  border-radius: 12px;
  box-shadow: 0px 3px 14px rgba(0,0,0,0.05);
  line-height: 16px;
  font-size: 12px;
  width: ${width}px;
  `;
};
export const makeTooltipArrow = (props) => {
    const { align } = props;
    const validatedPosition = getPosition(props);
    const rotate = {
        top: '180deg',
        right: '-90deg',
        bottom: '0deg',
        left: '90deg',
    };
    const tooltipPosition = {
        top: 'top: calc(100% - 7px);',
        bottom: 'bottom: calc(100% - 7px);',
        left: 'left: calc(100% - 7px);',
        right: 'right: calc(100% - 7px);',
    };
    const tooltipAlignV = {
        start: `top: 0px; transform: rotate(${rotate[validatedPosition]});`,
        center: `top: 50%; transform: translate(0, -50%) rotate(${rotate[validatedPosition]});`,
        end: `bottom: 0px; transform: rotate(${rotate[validatedPosition]});`,
    };
    const tooltipAlignH = {
        start: `left: 5px; transform: rotate(${rotate[validatedPosition]});`,
        center: `left: 50%; transform: translate(-50%, 0) rotate(${rotate[validatedPosition]});`,
        end: `right: 12px; transform: rotate(${rotate[validatedPosition]});`,
    };
    return `
  position: absolute;
  z-index: 10;
  ${tooltipPosition[validatedPosition]}
  ${validatedPosition === 'right' || validatedPosition === 'left' ? tooltipAlignV[align] : tooltipAlignH[align]};`;
};
